module.exports = __webpack_public_path__ + "img/setting.0b48e25c.svg";